"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var WrapTableActions = /** @class */ (function (_super) {
    __extends(WrapTableActions, _super);
    function WrapTableActions(props) {
        return _super.call(this, props) || this;
    }
    WrapTableActions.prototype.render = function () {
        return (React.createElement("div", { style: { display: "flex", flexDirection: "row", flexWrap: "nowrap", justifyContent: "center", alignSelf: "center" } }, this.props.children));
    };
    return WrapTableActions;
}(React.Component));
exports.default = WrapTableActions;



//////////////////
// WEBPACK FOOTER
// ./src/shared/components/table_actions/WrapTableActions.tsx
// module id = 12
// module chunks = 0